module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAAdElEQVR4AWOgF/j/AANhgEGi4dfXV7++viZWw8c3D24dqL59oOLLm2uENfz9++/ipStXDs54dCDv08Xi/39/Ebbh+7trzw/33zy0+dO7J0Q56duTfY/XNF9Zterl08dEafj35/fne3c/3b0LZAC5gzHi6AQAWMZTKy82Kr4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VA.png
// module id = 1295
// module chunks = 0